import React, { useContext } from 'react';
import { CompanyContext } from '../../../context/CompanyContext';
import { FileEntityType } from '../../../types/file';
import { FileViewLoader } from '../../../VentoryUI/components/common/File';
import VentoryWhiteLogo from './VentoryWhiteLogo';

export default function CompanyLogo() {
  const { currentCompany } = useContext(CompanyContext);

  const logo = currentCompany.settings.companyLogo;

  if (logo) {
    return <FileViewLoader className='object-fill' fileId={logo} fileEntityType={FileEntityType.company} />;
  }

  return <VentoryWhiteLogo />;
}
